var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultImageProps } from './defaults';
import { isValidUrl } from '@feb-team/data-logic';
import checkWebp from './checkWebp';
import { ImgTag } from '../../Utils/AtomicTag';
var LOADING_STATUS = {
    UNSTATRED: 0,
    LOADDING: 1,
    ERROR: 2,
    LOADED: 3,
};
// 1 x 1 白图
var blankImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURQAAAKd6PdoAAAABdFJOUwBA5thmAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.getFinalSrc = function () {
            var _a = _this.props, src = _a.src, enableWebp = _a.enableWebp;
            var finalSrc = src;
            if (!(finalSrc && isValidUrl(src))) {
                console.warn('请输入正确的图片地址');
                return finalSrc;
            }
            var webpShow = checkWebp();
            if (enableWebp && webpShow && finalSrc.match(/\.(png|jpg)(!q\d+)?$/)) {
                finalSrc = finalSrc + ".webp";
            }
            return finalSrc;
        };
        _this.startLoad = function () {
            _this.setState({
                status: LOADING_STATUS.LOADDING,
            });
            var originSrc = _this.props.src;
            var loader = new window.Image();
            loader.onerror = function () {
                _this.setState({
                    status: LOADING_STATUS.ERROR,
                });
                if (_this.props.src === originSrc && _this.props.onError) {
                    _this.props.onError(originSrc);
                }
            };
            loader.onload = function () {
                _this.setState({
                    status: LOADING_STATUS.LOADED,
                });
                if (_this.props.src === originSrc && _this.props.onLoad) {
                    _this.props.onLoad(originSrc);
                }
            };
            loader.src = _this.getFinalSrc();
        };
        _this.state = {
            status: LOADING_STATUS.UNSTATRED,
        };
        return _this;
    }
    Image.prototype.componentDidMount = function () {
        this.startLoad();
    };
    Image.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.src !== this.props.src) {
            this.startLoad();
        }
    };
    Image.prototype.render = function () {
        var _a = this.props, prefix = _a.prefix, className = _a.className, enableWebp = _a.enableWebp, onLoad = _a.onLoad, onError = _a.onError, src = _a.src, rest = __rest(_a, ["prefix", "className", "enableWebp", "onLoad", "onError", "src"]);
        var status = this.state.status;
        var renderedSrc = this.state.status === LOADING_STATUS.LOADED ? this.getFinalSrc() : blankImage;
        var extraClassName = '';
        if (status === LOADING_STATUS.LOADDING) {
            extraClassName = prefix + "-loading";
        }
        if (status === LOADING_STATUS.ERROR) {
            extraClassName = prefix + "-error";
        }
        if (status === LOADING_STATUS.LOADED) {
            extraClassName = prefix + "-loaded";
        }
        return (React.createElement(ImgTag, __assign({ name: Image.NAME, atomics: 'text-base', className: extraClassName + " " + className, src: renderedSrc }, rest)));
    };
    Image.defaultProps = defaultImageProps;
    Image.NAME = 'image';
    Image.displayName = 'Image';
    return Image;
}(PureComponent));
export { Image };
